"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M18 2H6v2H4.746a3.825 3.825 0 00-1.832 7.183L11 15.593v2.74L6 20v2h12v-2l-5-1.667v-2.74l8.086-4.41A3.825 3.825 0 0019.254 4H18V2zm0 8.588V6h1.254a1.825 1.825 0 01.874 3.427L18 10.588zM6 6v4.588l-2.128-1.16A1.825 1.825 0 014.746 6H6zm6-2l1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;